import gql from 'graphql-tag';
import apollo from '../apollo';

const getMatchedResultQuery = gql`
  mutation($accountId: ID!, $jobProfileId: ID!, $assessmentId: ID!, $locale: Locale!) {
    jobProfileMatchResults(
      accountId: $accountId
      jobProfileId: $jobProfileId
      assessmentId: $assessmentId
      locale: $locale
    ) {
      overallMatch
      distortionResults {
        code
        displayName
        benchmarkLow
        benchmarkHigh
        score
      }
      behaviorSectionMatchResults {
        displayName
        matchPercent
        dimensionMatchResults {
          ...asmtMatchedResult
        }
      }
      cognitiveSectionMatchResults {
        displayName
        matchPercent
        dimensionMatchResults {
          ...asmtMatchedResult
        }
      }
      interestsSectionMatchResults {
        displayName
        matchPercent
        dimensionMatchResults: interestsDimensionsMatchResults {
          code
          displayName
          assessmentPriority
          jobPriority
        }
      }
    }
  }

  fragment asmtMatchedResult on DimensionMatchResult {
    code
    displayName
    benchmarkLow
    benchmarkHigh
    score
  }
`;

const getStandardMatchedResultQuery = gql`
  mutation($accountId: ID!, $standardJobId: ID!, $assessmentId: ID!, $locale: Locale!) {
    standardJobProfileMatchResults(
      accountId: $accountId
      standardJobId: $standardJobId
      assessmentId: $assessmentId
      locale: $locale
    ) {
      overallMatch
      distortionResults {
        code
        displayName
        benchmarkLow
        benchmarkHigh
        score
      }
      behaviorSectionMatchResults {
        displayName
        matchPercent
        dimensionMatchResults {
          ...asmtMatchedResult
        }
      }
      cognitiveSectionMatchResults {
        displayName
        matchPercent
        dimensionMatchResults {
          ...asmtMatchedResult
        }
      }
      interestsSectionMatchResults {
        displayName
        matchPercent
        dimensionMatchResults: interestsDimensionsMatchResults {
          code
          displayName
          assessmentPriority
          jobPriority
        }
      }
    }
  }
  
  fragment asmtMatchedResult on DimensionMatchResult {
    code
    displayName
    benchmarkLow
    benchmarkHigh
    score
  }

  `;

export const getJobMatchedResult = formValues => apollo
  .mutate({
    mutation: getMatchedResultQuery,
    variables: {
      accountId: formValues.accountId,
      jobProfileId: formValues.jobProfileId,
      assessmentId: formValues.assessmentId,
      locale: formValues.locale,
    },
  })
  .then(res => res.data);

export const getStandardJobMatchedResult = formValues => apollo
  .mutate({
    mutation: getStandardMatchedResultQuery,
    variables: {
      accountId: formValues.accountId,
      standardJobId: formValues.standardJobId,
      assessmentId: formValues.assessmentId,
      locale: formValues.locale,
    },
  })
  .then(res => res.data);

const REMOVE_ASMT_MUTATION = gql`
  mutation($input: DeleteAssessmentInput!) {
    deleteAssessment(input: $input) {
      assessmentId
    }
  }
`;

export const removeAssessment = input => apollo
  .mutate({
    mutation: REMOVE_ASMT_MUTATION,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const UPDATE_SUBSCRIBE_ASSESSMENT = gql`
  mutation($input: ToggleSubscribeAssessmentInput!) {
    toggleSubscribeAssessment(input: $input) {
      assessment {
        id
        subscribed
        assessmentOptions {
          notificationEmails
          reportTypes
          jobProfileIdForSingleJobProfileReports
          jobProfileIdsForMultipleJobProfileReports
          sendingIndividualReport
          printerFriendlyReport
          reportPreferLocale
        }
      }
    }
  }
`;

export const subscribeAssessment = input => apollo
  .mutate({
    mutation: UPDATE_SUBSCRIBE_ASSESSMENT,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const UPDATE_ASSESSMENT_MUTATE = gql`
  mutation updateAssessment($input: UpdateAssessmentInput!) {
    updateAssessment(input: $input) {
      assessment {
        id
        subscribed
        assessmentOptions {
          notificationEmails
          reportTypes
          jobProfileIdForSingleJobProfileReports
          jobProfileIdsForMultipleJobProfileReports
          sendReportsWhenAssessmentIsComplete
          sendingIndividualReport
          printerFriendlyReport
          reportPreferLocale
        }
      }
    }
  }
`;

export const updateAssessment = input => apollo
  .mutate({
    mutation: UPDATE_ASSESSMENT_MUTATE,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const sendInvitation = ({ mutation, input }) => apollo
  .mutate({
    mutation,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const sendRemind = ({ mutation, input }) => apollo
  .mutate({
    mutation,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const GET_ASSESSMENT_URL = gql`
  query getAssessmentUrl($assessmentId: ID!, $accountId: ID!) {
    getAssessmentUrl(assessmentId: $assessmentId, accountId: $accountId)
  }
`;

export const previewAsmt = ({ accountId, assessmentId }) => apollo
  .query({
    query: GET_ASSESSMENT_URL,
    variables: {
      assessmentId,
      accountId,
    },
  })
  .then(res => res.data);
